<template>
  <div>
    <div v-if="! isModal" class="level is-variable bd-klmn-columns is-1 is-marginless">
      <div class="level-left">
        <b-button
          class="filter-button is-hidden-mobile"
          size="is-circle"
          icon-left="filter-remove"
          @click="clearFilter"
        />
        <div class="filter-tags">
          <b-tag
            v-for="(value, index) in filtered"
            :key="index"
            type="is-purple"
            closable
            @close="removeFilter(value)"
          >
            {{ $t('filter.' + value) }}
          </b-tag>
        </div>
      </div>
      <div class="level-right">
        <slot name="header-right" />
      </div>
    </div>
    <b-table
      :data="cars"
      :loading="isLoading"

      :current-page.sync="pagination.page"
      :total="pagination.total"
      :per-page="pagination.perPage"

      :default-sort-direction="sort.defaultOrder"
      :default-sort="[sort.field, sort.order]"

      striped
      sticky-header
      paginated
      hoverable
      backend-sorting
      backend-pagination

      class="no-wrap custom-table"

      @page-change="onPageChange"
      @sort="onSort"
    >
      <template slot-scope="props">
        <b-table-column :label="$t('filter.status')" custom-key="actions" class="is-actions-cell" centered sortable field="status">
          <template slot="header" slot-scope="{ column }">
            <b-dropdown v-model="filter.status" aria-role="list">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item
                v-for="(status, index) in statusFilters"
                :key="index"
                :value="status.value"
                aria-role="listitem"
              >
                <span>{{ status.name }}</span>
              </b-dropdown-item>
            </b-dropdown>

            {{ column.label }}
          </template>
          <b-switch
            v-model="props.row.ready"
            type="is-purple"
            @input="statusSwitch(props.index)"
          >
            {{ $t(`itemStatus.${props.row.ready}`) }}
          </b-switch>
        </b-table-column>

        <b-table-column label="Plaka" field="plate" centered sortable>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item aria-role="menu-item" :focusable="false">
                <b-input v-model="filter.plate" :placeholder="$t('plateSearch')" size="is-small" autocomplete="off" type="search" />
              </b-dropdown-item>
            </b-dropdown>

            {{ column.label }}
          </template>
          <span class="tag is-abbr-like">
            {{ props.row.plate }}
          </span>
        </b-table-column>

        <b-table-column :label="$t('brand')" field="brand" centered sortable>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item aria-role="menu-item" :focusable="false">
                <b-input v-model="filter.brand" :placeholder="$t('brandSearch')" size="is-small" autocomplete="off" type="search" />
              </b-dropdown-item>
            </b-dropdown>

            {{ column.label }}
          </template>
          {{ props.row.brand }}
        </b-table-column>

        <b-table-column :label="$t('model')" field="model" centered sortable>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item aria-role="menu-item" :focusable="false">
                <b-input v-model="filter.model" :placeholder="$t('modelSearch')" size="is-small" autocomplete="off" type="search" />
              </b-dropdown-item>
            </b-dropdown>

            {{ column.label }}
          </template>
          {{ props.row.model }}
        </b-table-column>

        <b-table-column label="Cinsi" field="vehicle_type" centered>
          {{ props.row.vehicle_type ? props.row.vehicle_type.name : '' }}
        </b-table-column>

        <b-table-column :label="$t('area')" field="area" centered>
          <template slot="header" slot-scope="{ column }">
            <b-dropdown aria-role="menu" class="search-dropdown" :close-on-click="false">
              <b-icon slot="trigger" icon="magnify" class="search-icon pointer" custom-size="mdi-20px" />
              <b-dropdown-item aria-role="menu-item" :focusable="false">
                <b-input v-model="filter.area" :placeholder="$t('areaSearch')" size="is-small" autocomplete="off" type="search" />
              </b-dropdown-item>
            </b-dropdown>

            {{ column.label }}
          </template>
          {{ props.row.area ? props.row.area.name : '' }}
        </b-table-column>
        
        <b-table-column :label="$t('totalVoyage')" field="total_voyage" centered sortable>
          <span class="tag is-abbr-like">
            {{ props.row.total_voyage }}
          </span>
        </b-table-column>

        <b-table-column :label="$t('totalDistance')" field="total_distance" centered sortable>
          <span class="tag is-abbr-like">
            {{ props.row.total_distance }}
          </span>
        </b-table-column>

        <b-table-column :label="$t('totalTime')" field="total_time" centered sortable>
          <span v-if="props.row.total_time_min" class="tag is-abbr-like">
            {{ props.row.total_time_min }}
          </span>
        </b-table-column>
      </template>

      <template slot="bottom-left">
        <div v-if="pagination.total > 0" class="has-text-left subtitle help">
          {{ $t('paginationShowing', [pagination.total.toLocaleString(), ((pagination.page * pagination.perPage) - pagination.perPage) + 1, ((pagination.page * pagination.perPage) > pagination.total ? pagination.total : (pagination.page * pagination.perPage)) ]) }}
        </div>
      </template>

      <section slot="empty" class="section">
        <div class="content has-text-grey has-text-centered">
          <template v-if="!isLoading">
            <p>
              <b-icon icon="table" size="is-large" />
            </p>
            <p>{{ $t('nodata') }}</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import $ from 'jquery'

export default {
  name: 'CarsTable',
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      pagination: {
        total: 0,
        page: 1,
        count: 0,
        perPage: 30
      },
      sort: {
        defaultOrder: 'asc',
        field: 'plate',
        order: 'asc',
      },
      statusFilters: [
        {
          name: 'Tümü',
          value: '',
        },
        {
          name: 'Aktif',
          value: '1',
        },
        {
          name: 'Pasif',
          value: '0',
        }
      ],
      isLoading: true,
      inputTrigger: false,
      cars: [],
      filtered: [],
      filter: {},
    }
  },
  computed: {
    //
  },
  watch: {
    filter: {
      handler () {
        this.filterAction()
      },
      deep: true
    }
  },
  created () {
    this.filter = this.defaultFilters()
  },
  mounted () {
    // this.getCars();
  },
  methods: {
    filterAction: debounce(function () {
      this.filterShow()
      this.getCars();
    }, 350),
    generateParams () {
      return [
        `sort_by=${this.sort.field}`,
        `sort_order=${this.sort.order}`,
        `page=${this.pagination.page}`,
        `ready=${this.filter.status}`,
        `plate=${this.filter.plate}`,
        `brand=${this.filter.brand}`,
        `model=${this.filter.model}`,
        `area=${this.filter.area}`,
      ].join('&');
    },
    getCars () {
      const params = this.generateParams();
      let responseType = 'json'
      this.isLoading = true

      this.$http({
          url: `list-all-cars?${params}`,
          method: 'GET',
          responseType: responseType,
        })
        .then(response => {
          this.cars = [];

          if (response.data) {
            if (response.data.meta) {
              this.pagination.total = response.data.meta.total
              this.pagination.perPage = response.data.meta.per_page
              this.pagination.page = response.data.meta.current_page
              this.pagination.count = response.data.meta.to
            } else {
              this.pagination.total = 0
            }

            this.cars = response.data.data
          }
          this.isLoading = false
          this.$nextTick(() => {
            this.jqInputTrigger()
            $('.table-wrapper').scrollTop(0)
          })
        })
    },
    filterShow () {
      this.filtered = this.$_.keys(this.$_.omitBy(this.filter, this.$_.isEmpty))
    },
    clearFilter () {
      this.filter = this.defaultFilters()
    },
    defaultFilters () {
      return {
        status: '',
        plate: '',
        brand: '',
        model: '',
        area: '',
      }
    },
    onSort (field, order) {
      this.pagination.page = 1
      this.sort.field = field
      this.sort.order = order

      this.getCars()
    },
    onPageChange (page) {
      this.pagination.page = page
      this.getCars()
    },
    jqInputTrigger () {
      if (this.inputTrigger) return;

      $('.dropdown-trigger').click(function (e) {
        e.stopPropagation()
        $(this).parent().find('input, select').first().focus()
      })
      $('.search-dropdown input').keypress(function (e) {
        if (e.which == '13') {
          $('body').trigger('click')
        }
      });
      $('.dropdown').click(function (e) {
        e.stopPropagation()
      })
      this.inputTrigger = true;
    },
    removeFilter (filter) {
      const defaultFilters = this.defaultFilters();
      this.filter[filter] = defaultFilters[filter];
    },
    statusSwitch (index) {
      const ready = this.cars[index].ready;
      const id = this.cars[index].id;

      this.$http.put('car-edit', {
        id: id,
        ready: ready
      });
    }
  }
}
</script>
